import React from "react";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import useShowMessages from "../hooks/useShowMessages";

const SnackBar = props => {
  const {
    message,
    messageSeverity,
    showSnackbar,
    setShowSnackbar
  } = useShowMessages();

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setShowSnackbar(false);
  };

  function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
  }

  return (
    <Snackbar open={showSnackbar} autoHideDuration={6000} onClose={handleClose}>
      <Alert onClose={handleClose} severity={messageSeverity}>
        {message}
      </Alert>
    </Snackbar>
  );
};

export default SnackBar;
